import { gql, TypedDocumentNode } from '@apollo/client';
import { LINE_ITEM_FRAGMENT, LineItem } from '../useCart/cart.rest';

export type GetSavedItemsQueryVariables = {
  countryCode: string;
};

export type GetSavedItemsQuery = {
  savedItems: {
    __typename: 'RestSavedItems';
    data: LineItem[];
  };
};

export const GET_SAVED_ITEMS_QUERY: TypedDocumentNode<
  GetSavedItemsQuery,
  GetSavedItemsQueryVariables
> = gql`
  query GetSavedItemsQuery($countryCode: String!) {
    savedItems(countryCode: $countryCode)
      @rest(
        type: "RestSavedItems"
        endpoint: "moda"
        # TODO: make this endpoint not paginated in mojo
        path: "/v3.5/saved_items?page[size]=1000&page[number]=1&country_code={args.countryCode}"
      ) {
      data @type(name: "RestLineItemData") {
        ...LineItemFragment
      }
    }
  }
  ${LINE_ITEM_FRAGMENT}
`;
